import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';

interface Metrics {
  walletsMonitored: number;
  alertsSent: number;
  transactionsProcessed: number;
}

export const useMetrics = () => {
  const [metrics, setMetrics] = useState<Metrics | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/utils/get-metrics`);
        if (!response.ok) {
          throw new Error('Failed to fetch metrics');
        }
        const data = await response.json();
        setMetrics({
          walletsMonitored: data.walletsMonitored,
          alertsSent: data.alertsSent,
          transactionsProcessed: data.transactionsProcessed,
        });
        setLoading(false);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        setLoading(false);
      }
    };

    fetchMetrics();
  }, []);

  return { metrics, loading, error };
}; 